import Vue from 'vue'
import Main from './main.vue'

let RetentionConstructor = Vue.extend(Main)
const Retention = (options, props) => {
  options = options || {}
  let data = Object.assign({}, options, {
    afterClose: () => {
      if (typeof options?.afterClose === 'function') {
        options.afterClose()
      }
      // vm.$destroy()
    }
  })
  let instance = new RetentionConstructor({
    ...props,
    el: document.createElement('div'),
    data: data
  })
  instance.$mount()
  const key = '_APP_COUNT'
  let value = localStorage.getItem(key)
  value = isNaN(Number(value)) ? 0 : Number(value)
  localStorage.setItem(key, `${value + 1}`)
  document.body.appendChild(instance.$el)
  instance.visible = true
  return instance
}

export default Retention
